import type { Company } from '@hellodarwin/core/lib/features/entities';
import dayjs, { type Dayjs } from 'dayjs';

export interface ClientCompleteProfileModalForm {
  company_tag_goals?: string[];
  founded_at?: Dayjs | null;
  industry_subsector?: string[];
  npo_scopes_id?: string[];
}

const normalizeSelectIds = (ids?: string[] | null): string[] | undefined => {
  if (!Array.isArray(ids)) return undefined;

  return ids.filter((id): id is string => typeof id === 'string' && id !== '');
};

export const buildCompleteProfileModalFormValues = (
  company: Company,
): Partial<ClientCompleteProfileModalForm> => ({
  company_tag_goals: normalizeSelectIds(company.company_tag_goals),
  founded_at: company.founded_at ? dayjs(company.founded_at) : null,
  industry_subsector: normalizeSelectIds(company.industry_subsector),
  npo_scopes_id: normalizeSelectIds(company.npo_scopes),
});
